<template>
  <Card class="keyword-planner-choose-keywords">
    <div class="keyword-planner-choose-keywords__content">
      <img src="~@/assets/images/keyword-planner.svg" />
      <h2 class="keyword-planner-choose-keywords__title">
        {{ $t('ADVERTISEMENT.KEYWORDPLANNER.INSIDE_TITLE') }}
      </h2>
      <p class="keyword-planner-choose-keywords__description">
        {{ $t('ADVERTISEMENT.KEYWORDPLANNER.INSIDE_DESCRIPTION') }}
      </p>

      <KeywordPlannerChooseKeywordsForm
        class="keyword-planner-choose-keywords__form"
        :is-loading="isLoading"
        @submit="submitForm"
      />

      <p class="keyword-planner-choose-keywords__extra-hint">
        {{ $t('ADVERTISEMENT.KEYWORDPLANNER.EXTRA_HINT') }}
      </p>
    </div>
  </Card>
</template>

<script>
import Card from '@@/common/Card';

import KeywordPlannerChooseKeywordsForm from './KeywordPlannerChooseKeywordsForm';

export default {
  name: 'KewyordPlannerChooseKeyword',
  components: {
    Card,
    KeywordPlannerChooseKeywordsForm,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    submitForm(items) {
      this.$emit('submit', items);
    },
  },
};
</script>

<style lang="scss">
.keyword-planner-choose-keywords {
  &__content {
    padding: $global-padding * 5 $global-padding * 3;

    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__title {
    margin-top: $global-margin;
  }

  &__description,
  &__extra-hint {
    text-align: center;
    font-size: rem-calc(14px);
    font-weight: 400;
    color: #909399;
    margin: 0;
  }

  &__form {
    width: 100%;
    max-width: rem-calc(480px);

    margin-top: $global-margin * 3.125;
    margin-bottom: $global-margin * 2.5;
  }
}
</style>
